var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2904_4061)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0402 9.49048C12.3923 10.9026 10.8874 11.6033 9.65136 11.0818C9.61157 11.384 9.59082 11.6943 9.59082 12.0107C9.59082 15.1272 11.6023 17.6536 14.0835 17.6536C16.5648 17.6536 18.5763 15.1272 18.5763 12.0107C18.5763 8.89404 16.5648 6.36768 14.0835 6.36768C13.6566 6.36768 13.2435 6.44263 12.8523 6.58228C13.4024 7.34888 13.5091 8.46826 13.0402 9.49048Z",
    fill: "#9e9e9f"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.7451 11.144C1.21987 10.0089 1.79586 8.91882 2.4661 7.887C3.39803 6.60983 5.64492 3.83618 7.1771 2.959C9.20326 1.54226 11.6109 0.772148 14.0831 0.75C19.8451 0.75 24.8781 4.945 27.4201 11.14C27.6376 11.6893 27.6376 12.3007 27.4201 12.85C26.4077 15.4078 25.6191 16.5888 23.6111 18.831L23.5526 18.8818C21.8554 20.3545 20.8215 21.2516 17.7341 22.637C16.5568 23.0314 15.3247 23.2382 14.0831 23.25C8.3211 23.25 3.2881 19.055 0.7451 12.854C0.527675 12.3047 0.527675 11.6933 0.7451 11.144ZM20.8018 12.0106C20.8018 16.671 17.794 20.449 14.0835 20.449C10.3731 20.449 7.36523 16.671 7.36523 12.0106C7.36523 7.35025 10.3731 3.57227 14.0835 3.57227C17.794 3.57227 20.8018 7.35025 20.8018 12.0106Z",
    fill: "#9e9e9f"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2904_4061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open_eye.e039d71a84098aa85ac679c94b38bc88.svg";
export { ForwardRef as ReactComponent };